import { ILeagueConfig } from 'fitbeat.models';
import React, { CSSProperties, useState } from 'react';
import LeagueListEditor from '../formHelpers/LeagueListEditor';
import LeagueTable from '../tables/LeagueTable';

export interface ILeaguesTabProps {
  leagueConfigs: ILeagueConfig[];
  onAddLeague: (league: ILeagueConfig) => void;
  onDeleteLeague: (index: number) => void;
  onUpdateLeague: (index: number, league: ILeagueConfig) => void;
}

const LeaguesTab: React.FC<ILeaguesTabProps> = ({
  leagueConfigs,
  onAddLeague,
  onDeleteLeague,
  onUpdateLeague,
}) => {
  const [selectedLeagueIndex, setSelectedLeagueIndex] = useState<number | null>(null);

  const handleSelectLeague = (index: number) => {
    setSelectedLeagueIndex(index);
  };

  const handleClearSelection = () => {
    setSelectedLeagueIndex(null);
  };

  const handleUpdateLeague = (index: number, league: ILeagueConfig) => {
    onUpdateLeague(index, league);
    setSelectedLeagueIndex(null);
  };

  return (
    <div style={styles.formRow}>
      <div style={styles.tableCol}>
        <h1>Leagues</h1>
        <LeagueTable
          leagues={leagueConfigs}
          selectedLeagueIndex={selectedLeagueIndex}
          onSelectLeague={handleSelectLeague}
        />
      </div>
      <div style={styles.editorCol}>
        <LeagueListEditor
          title={selectedLeagueIndex !== null ? 'Update League' : 'Create League'}
          leagues={leagueConfigs}
          selectedLeagueIndex={selectedLeagueIndex}
          onAddLeague={onAddLeague}
          onUpdateLeague={handleUpdateLeague}
          onDeleteLeague={onDeleteLeague}
          onClearSelection={handleClearSelection}
        />
      </div>
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  formRow: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    marginRight: '40px',
  },
  tableCol: {
    width: '80%',
    minWidth: 0,
  },
  editorCol: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: '20%',
    height: '100%',
    zIndex: 2,
    backgroundColor: '#fff',
    boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.35)',
  },
};

export default LeaguesTab;
